import { render, staticRenderFns } from "./MyBed.vue?vue&type=template&id=37b056ff"
import script from "./MyBed.vue?vue&type=script&lang=js"
export * from "./MyBed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports